import React from 'react';
import { useNavigate } from 'react-router-dom';
import ElectricCar from '../../assets/icons/png/ElectricCar.png';
import DomainNames from '../../assets/icons/png/DomainNames.png';
import Graphs from '../../assets/icons/png/Graphs.png';
import ArrowNextIconSVG from '../../assets/icons/svg/ArrowNextIconSVG';

const WithoutParts = () => {
  const navigate = useNavigate(); 

  const handleClick = () => {
    navigate('/store'); 
  };

  return (
    <div style={styles.main}>
      <div style={styles.contentContainer}>
        <h2 style={styles.heading}>
          Postavi svoju ponudu delova i izloži svoj asortiman brzo i lako!
        </h2>
        <p style={styles.paragraph}>
          Preko 5.000 kupaca je do sada naručilo delove <br />preko Smart Part platforme.
        </p>
        <div style={styles.imageRow}>
          <div style={styles.imageBox}>
            <img src={ElectricCar} alt="Electric Car" style={styles.icon} />
            <h3 style={styles.imageTitle}>1. Dodaj marke <br />i modele vozila</h3>
            <p style={styles.imageSubtitle}>Odaberi vozila za koja prodaješ delove kako bi dobijao prave upite od zainteresovanih kupaca.</p>
          </div>
          <div style={styles.imageBox}>
            <img src={DomainNames} alt="Domain Names" style={styles.icon} />
            <h3 style={styles.imageTitle}>2. Prati zahteve kupaca <br />i šalji ponude</h3>
            <p style={styles.imageSubtitle}>Kupci šalju zahteve za delove, a ti možeš da im direktno odgovoriš sa ponudom</p>
          </div>
          <div style={styles.imageBox}>
            <img src={Graphs} alt="Graphs" style={styles.icon} />
            <h3 style={styles.imageTitle}>3. Povećaj prodaju delova <br /> iz svog asortimana</h3>
            <p style={styles.imageSubtitle}>Poveži se direktno sa kupcima i unapredi svoje poslovanje!</p>
          </div>
        </div>
      </div>
      <div style={styles.buttonWrapper}>
        <div style={styles.buttonWithText}>
          <button style={styles.ctaButton} onClick={handleClick}>
            Dodaj modele automobila
            <ArrowNextIconSVG />
          </button>
          <p style={styles.underButtonText}>
            Odaberi za koje modele nudiš delove
          </p>
        </div>
      </div>
    </div>
  );
};

export default WithoutParts;


const styles = {
 
  main: {
    flex: 1,
    padding: '40px',
    textAlign: 'center',
  },
  contentContainer: {
    borderRadius: '8px',
    border: '1px solid rgba(203, 213, 225, 1)',
    opacity: 1,
    backgroundColor: 'rgba(243, 244, 246, 1)',
    padding: '40px',
  },
  heading: {
    opacity: 1,
    color: '#000000',
    fontSize: '34px',
    fontWeight: '700',
    fontStyle: 'bold',
    letterSpacing: '0.25px',
    textAlign: 'center',
    lineHeight: '42px',
    marginBottom: '30px',
  },
  paragraph: {
    opacity: 1,
    color: '#000000',
    fontSize: '24px',
    fontWeight: '400',
    fontStyle: 'regular',
    letterSpacing: '0px',
    textAlign: 'center',
    lineHeight: '32px',
    marginBottom: '30px',
  },
  imageRow: {
    display: 'flex',
    gap: '20px',
    marginBottom: '30px',
    justifyContent: 'center',
  },
  imageBox: {
    width: '350px',
    height: '252px',
    textAlign: 'center',
  },
  icon: {
    width: '161px',
    height: '124px',
    objectFit: 'contain',
    marginBottom: '10px',
  },
  imageTitle: {
    opacity: 1,
    color: '#000000',
    fontSize: '20px',
    fontWeight: '600',
    fontStyle: 'SemiBold',
    letterSpacing: '0px',
    textAlign: 'center',
    lineHeight: '28px',
    marginBottom: '10px',
  },
  imageSubtitle: {
    opacity: 1,
    color: '#000000',
    fontSize: '16px',
    fontWeight: '400',
    fontStyle: 'Regular',
    letterSpacing: '0px',
    textAlign: 'center',
    lineHeight: '24px',
  },
  ctaButton: {
    backgroundColor: '#000',
    padding: '12px 24px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    marginTop: '20px',
    opacity: 0.99,
color: "#FFFFFF",
fontSize: '20px',
fontWeight: 700,
textAlign: 'center',
lineHeight: '20px',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end', 
    marginTop: '20px',
  },
  
  buttonWithText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  
  
  underButtonText: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '16px',
    fontWeight: '400',
    fontStyle: 'Regular',
    letterSpacing: '0px',
    textAlign: 'center',
    lineHeight: '24px',
    marginTop: '10px',
    marginRight:'20px'
  },
  

};
